import React from 'react'
import { Container, Typography, Box, Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'
// import { CreateBookingButton } from "./CreateBookingButton";
import { useNavigate } from 'react-router-dom'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
    title: {
        textAlign: 'center',
        marginBottom: theme.spacing(2),
    },
    center: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: theme.spacing(30),
    },
    bookingBtn: {
        textTransform: 'none',
    },
}))

export const NoBookings = () => {
    const classes = useStyles()
    const navigate = useNavigate()
    return (
        <Container className={clsx(classes.center)}>
            <Box>
                <Typography className={classes.title} variant="h6" component="p" color="textSecondary">
                    No bookings
                </Typography>
                {/* <CreateBookingButton />
                 */}
                <Button
                    className={classes.bookingBtn}
                    variant="contained"
                    color="primary"
                    size="medium"
                    onClick={() => navigate('/create-booking')}
                >
                    Create Booking
                </Button>
            </Box>
        </Container>
    )
}
